import React from 'react'
import * as Dialog from "@radix-ui/react-dialog";
// import { CloseIcon } from '@/utils/icons';

const Modal = ({ isOpen, onChange, title, descr, children }) => {


  return (
    <Dialog.Root
      open={isOpen}
      defaultOpen={isOpen}
      onOpenChange={onChange}
    >
      <Dialog.Portal>
        <Dialog.Overlay className='bg-neutral-900/90 backdrop-blur-sm fixed inset-0 z-[5]' />
        <Dialog.Content className='fixed drop-shadow-md border border-neutral-700 top-[50%] z-[6] left-[50%] max-h-full h-full md:h-auto md:max-h-[85vh] w-full md:w-[90vw] md:max-w-[450px] translate-x-[-50%] translate-y-[-50%] rounded-md bg-neutral-800 p-[25px] focus:outline-none '>

          <Dialog.Title className='text-xl text-center  mb-4'>{title}</Dialog.Title>
          <Dialog.Description className='mb-5 text-sm leading-normal text-center'>{descr}</Dialog.Description>
          <div>
            {children}
          </div>

          <Dialog.Close /* onClick={() => {} }  */ asChild>
            <button className='text-neutral-400 hover:text-white absolute top-[25px] right-[20px] inline-flex size-7 appearance-none items-center justify-center rounded-full focus:outline-none'>
              <i className='ri-close-line' size={26} />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>

    </Dialog.Root>
  )
    
}

export default Modal